// extracted by mini-css-extract-plugin
module.exports = {"Country":"Country_Country__uEeJd","Image":"Country_Image__1s3Hn","Info":"Country_Info__2MGPM"};